export default __webpack_public_path__ + "static/media/slider_inicio_2.cf4e0b40.jpg";